import { useEffect, useRef } from 'react';

import { useRealtimeFrame } from '../../shared/api/realtime';

// A burst of webhooks is one redraw: the first frame arms the timer, the rest ride on it.
const THROTTLE_MS = 2_000;

/** Calls `onChange` at most every 2 s while runs of the watched flows are created or move. */
export const useRunChartLive = (flowIds: readonly string[], onChange: () => void): void => {
  const timer = useRef<number | undefined>(undefined);
  const latest = useRef(onChange);
  latest.current = onChange;

  const bump = () => {
    if (timer.current !== undefined) return;
    timer.current = window.setTimeout(() => {
      timer.current = undefined;
      latest.current();
    }, THROTTLE_MS);
  };
  const wanted = (flowId: string) => flowIds.length === 0 || flowIds.includes(flowId);

  useRealtimeFrame('flow_copy.created', (frame) => {
    if (wanted(frame.copy.flowId)) bump();
  });
  useRealtimeFrame('flow_run.updated', (frame) => {
    if (wanted(frame.run.flowId)) bump();
  });
  useRealtimeFrame('flow_copy.skipped', bump);
  useRealtimeFrame('resync', bump);

  useEffect(() => () => window.clearTimeout(timer.current), []);
};
